import { AppConfigId, AppEnv, AppIdentifier, BaseEnv } from "@aipb/gulliver/env/model";
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from './config';
import { APP_CONFIG } from './env.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseEnvService<EnvType extends AppEnv, ConfigType extends AppConfig<EnvType>> {
  protected _configs: {
    [configId: string]: ConfigType;
  } = {};

  protected constructor(
    @Inject(APP_CONFIG) protected config: BaseEnv,
    public readonly appId: AppIdentifier,
    private mapper: (config: AppEnv) => ConfigType
  ) {
    this.init();
  }

  private _activeConfigId = 'default';

  get activeConfigId(): string {
    return this._activeConfigId;
  }

  get env(): ConfigType {
    return this.getEnv(this._activeConfigId);
  }

  init() {
    if (!(this.appId in this.config.applications)) {
      return;
    }

    for (const configId of Object.keys(this.config.applications[this.appId])) {
      if (!(configId in this._configs)) {
        this._configs[configId] = this.mapper(this.config.applications[this.appId][configId]);
      }
    }
  }

  setActiveConfigId(configId: AppConfigId) {
    this._activeConfigId = configId;
  }

  getEnv(configId: string): ConfigType {
    if (!(configId in this._configs)) {
      throw new Error(`Trying to access invalid configuration for app=${this.appId} and configId=${configId}`);
    }

    return this._configs[configId];
  }

  getConfigIds(): AppConfigId[] {
    return Object.keys(this._configs);
  }
}
